export default __webpack_public_path__ + "images/group-appointment.e2711bda.svg";